<template>
  <v-container :class="item.show ? '' : 'py-0'" fluid tag="section">
    <base-material-dialog
      :title='item.data === undefined ? "新建应收款" : "应收款编辑" '
      :dialog="item.show"
      @on-dialog-change='dialogChange'
      persistent
      :fullscreen='$isMobile'
      max-width='650'
    >
      <template v-slot:content>
        <v-card class="px-5" elevation="0">
          <v-form ref="form" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  label="回款编号"
                  readonly
                  hide-details='auto'
                  outlined
                  :rules="required"
                  v-model="form.collectNumber">
                  <template v-slot:append>
                    <v-btn fab x-small color="blue-grey" dark @click='collectNumber' class="mt-n1 mr-n4">
                      <v-icon dark>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-select
                  :items="returnedMoneyStateItems"
                  label="回款状态"
                  v-model="form.returnStateId"
                  hide-details='auto'
                  readonly
                  outlined
                  item-text='name'
                  item-value="id"
                  :rules="required"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
               <v-select
                 :items="returnedMoneyTypeItems"
                 label="回款类型"
                 v-model="form.returnTypeId"
                 hide-details='auto'
                 outlined
                 item-text='name'
                 item-value="id"
                 :rules="required"
               ></v-select>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-text-field label="回款金额" hide-details='auto' outlined :rules="number" v-model="form.money"></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
               <base-material-date
                  ref='date'
                  :rules="required"
                  hide-details='auto'
                  outlined
                  label='预计回款时间'
                  v-model='form.returnTimeStr'
                >
                </base-material-date>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12">
                <v-textarea rows='4' label="预计回款金额的明细划分（比如高企公示后)" outlined :rules="required" v-model="form.desc"></v-textarea>
              </v-col>
            </v-row>

          </v-form>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text class="text--disabled" @click='item.show = false'>
              关闭
            </v-btn>
            <v-btn color="primary" :loading="loading" @click='save'>
              保存
            </v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { save } from '@/api/contract/collect.js'
  import { getByPids } from '@/api/system/dictionary.js'
  import { serialNumber } from '@/utils/stringUtil.js'

  export default {
    name: 'CollectAdd',
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          type: 1, // 1. 直接保存2.传值到父页面
          data: null,
          contractId: ''
        })
      },
      surplusMoney: {
        type: Number,
        default: 0
      }
    },
    components: {
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => (/^[0-9]+(.[0-9]{1,2})?$|^(0|[1-9][0-9]*)$/.test(value) && value <= this.surplusMoney) || `金额必填且不得超过${this.surplusMoney}`,
        ],
        array: [
          value => value.length > 0 || '此项为必填项!'
        ],
        form: {
          id: '',
          contractId: '',
          collectNumber: '',
          returnTypeId: '',
          returnStateId: this.$constants.ReturnedMoneyState.UN_GET_MONEY_ID,
          money: '',
          returnTimeStr: '',
          returnTime: '',
          desc: ''
        },
        defForm: {
          id: '',
          contractId: '',
          collectNumber: '',
          returnTypeId: '',
          returnStateId: this.$constants.ReturnedMoneyState.UN_GET_MONEY_ID,
          money: '',
          returnTimeStr: '',
          returnTime: '',
          desc: ''
        },
        returnedMoneyTypeItems: [],
        returnedMoneyStateItems: []
      }
    },
    methods: {
      save () {
        this.form.returnTime = new Date(this.form.returnTimeStr).getTime() / 1000
        if (this.$refs.form.validate()) {
          if (this.item.type === 2) {
            this.item.show = false
            this.$emit("on-submit", JSON.parse(JSON.stringify(this.form)))
          } else {
            this.loading = true
            save(this.form).then(res => {
              if (res.status === 200) {
                this.item.show = false
                this.$emit("on-load-data")
                this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
              }
              this.loading = false
            })
          }
        }
      },
      collectNumber () {
        this.form.collectNumber = serialNumber('YD.', '.HK')
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          if (this.isEdit) {
            this.form = JSON.parse(JSON.stringify(this.item.data))
          } else {
            this.form = JSON.parse(JSON.stringify(this.defForm))
            this.collectNumber()
          }
        } else {
          this.$refs.form.resetValidation()
        }
        this.form.contractId = this.item.contractId
      },
      getTypes () {
        getByPids(
          {
            pids: [
              this.$constants.returnedMoneyTypePid,
              this.$constants.returnedMoneyStatePid
            ]
          }
        ).then(res => {
          if (res.status === 200) {
           const this_ = this
           res.data.forEach((result) => {
             if (this_.$constants.returnedMoneyTypePid === result.id) {
                this_.returnedMoneyTypeItems = result.data
             } else if (this_.$constants.returnedMoneyStatePid === result.id) {
                this_.returnedMoneyStateItems = result.data
             }
           })
          }
        })
      }
    },
    computed: {
      isEdit () {
        return this.item.data !== undefined && this.item.data !== null
      }
    },
    created () {
      this.getTypes()
    }
  }
</script>

<style>
</style>
